export enum SkippedRowReason {
  ABSENCE_REQUEST_ALREADY_EXISTS = "ABSENCE_REQUEST_ALREADY_EXISTS",
}

export default (reason: SkippedRowReason): string => {
  const reasonMessages: Record<SkippedRowReason, string> = {
    ABSENCE_REQUEST_ALREADY_EXISTS:
      "Nie zaimportowano zduplikowanych wniosków.",
  };

  return reasonMessages[reason] || "Nie zaimportowano z nieznanej przyczyny.";
};
